import axios from "axios";

export function createItemWs(qData, getState) {
  const state = getState();
  const jwtToken = state.authData[0].signInUserSession.accessToken.jwtToken;

  const headers = {
    Authorization: `Bearer ${jwtToken}`,
  };

  return axios
    .put(
      `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_ENV}/put-dynamodb`,
      qData,
      { headers }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
}

export function transactItemWs(qData, getState, options = {}) {
  const state = getState();
  const jwtToken = state.authData[0].signInUserSession.accessToken.jwtToken;

  const headers = {
    Authorization: `Bearer ${jwtToken}`,
  };

  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_ENV}/transact-dynamodb`,
      qData,
      { headers, ...(options.prepareWhatsAppFlow === true ? { params: { prepareWhatsAppFlow: true } } : {}) }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
}

export function updateItemWs(qData, getState, options = {}) {
  const state = getState();
  const jwtToken = state.authData[0].signInUserSession.accessToken.jwtToken;

  const headers = {
    Authorization: `Bearer ${jwtToken}`,
  };
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_ENV}/update-dynamodb`,
      qData,
      { headers, ...(options.prepareWhatsAppFlow === true ? { params: { prepareWhatsAppFlow: true } } : {}) }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
}
